
import { defineComponent } from "vue";

export default defineComponent({
  name: "TopThreeRepos",
  props: {
    repos: Array
  }
});
